// Cambio masivo de precios (plan Pro): subir o bajar por porcentaje o monto fijo,
// con redondeo opcional. Acá está solo la cuenta; la pantalla es BulkPricePanel.jsx.
import { parsePrice } from "./importCatalog.js";

export const ROUNDINGS = [0, 10, 50, 100];
export const MAX_PERCENT_UP = 500;
export const MAX_PERCENT_DOWN = 90;
// Igual que firestore.rules: el precio tiene que ser menor a 100 millones.
export const MAX_PRICE = 100000000;

// "15" o "12,5" -> 12.5. null si no es un número positivo.
export const parseAmount = (value) => {
    const s = String(value ?? "").trim().replace(",", ".");
    if (!/^[0-9]{1,9}(\.[0-9]{1,2})?$/.test(s)) return null;
    const n = Number(s);
    return n > 0 ? n : null;
}

// El precio guardado del producto como número (los viejos pueden estar como texto, "1500,50").
export const priceNumber = (price) => {
    const parsed = parsePrice(price);
    return parsed === null ? null : Number(parsed);
}

// Si los datos del cambio están completos. Devuelve el problema o "".
export const changeProblem = ({ kind, direction, amount }) => {
    const n = parseAmount(amount);
    if (String(amount ?? "").trim() === "") return "Escribí cuánto querés " + (direction === "down" ? "bajar" : "subir") + ".";
    if (n === null) return "Escribí un número mayor a 0, con hasta 2 decimales.";
    if (kind === "percent" && direction === "up" && n > MAX_PERCENT_UP) return `Podés subir hasta un ${MAX_PERCENT_UP}% por vez.`;
    if (kind === "percent" && direction === "down" && n > MAX_PERCENT_DOWN) return `Podés bajar hasta un ${MAX_PERCENT_DOWN}% por vez.`;
    return "";
}

const roundTo = (value, step) => {
    // Sin redondeo igual se lleva al peso: en una carta no se usan centavos.
    if (!step) return Math.round(value);
    // Nunca redondear a $0: como mínimo queda en un escalón.
    return Math.max(step, Math.round(value / step) * step);
}

// El precio nuevo de un precio, o null si el cambio no se puede aplicar.
export const newPrice = (price, { kind, direction, amount, rounding }) => {
    const n = parseAmount(amount);
    if (price === null || n === null) return null;
    const sign = direction === "down" ? -1 : 1;
    const raw = kind === "percent" ? price * (1 + sign * n / 100) : price + sign * n;
    if (raw <= 0) return null;
    const result = roundTo(raw, rounding);
    return result > 0 && result < MAX_PRICE ? result : null;
}

// Qué productos entran según el alcance elegido.
export const productsInScope = (products, { scope, category, selected }) => {
    if (scope === "category") return products.filter((p) => p.category === category);
    if (scope === "selected") return products.filter((p) => selected.has(p.id));
    return products;
}

// Arma la vista previa: qué cambia, qué queda igual y qué no se puede tocar (y por qué).
export const planPriceChange = (products, change) => {
    const ready = !changeProblem(change);
    const rows = products.map((product) => {
        const before = priceNumber(product.price);
        if (before === null) return { product, before, after: null, status: "invalid" };
        if (!ready) return { product, before, after: null, status: "pending" };
        const after = newPrice(before, change);
        if (after === null) return { product, before, after, status: change.direction === "down" ? "tooLow" : "tooHigh" };
        return { product, before, after, status: after === before ? "same" : "change" };
    });
    const count = (status) => rows.filter((r) => r.status === status).length;
    return {
        rows,
        update: rows.filter((r) => r.status === "change").map((r) => ({ product: r.product, price: r.after })),
        same: count("same"),
        skipped: count("invalid") + count("tooLow") + count("tooHigh")
    };
}

// Diferencia en texto para la vista previa: "+$150" o "−$80".
export const deltaLabel = (before, after) => {
    const d = Math.round((after - before) * 100) / 100;
    return (d >= 0 ? "+" : "−") + "$" + Math.abs(d).toLocaleString("es-AR");
}
